import { useEffect, useRef, useState } from "react";
import BPService from "../../services/resource/bpService";
import Modal from "../../componentes/modal/modal";
import CadastroBP from "./CadastroBP";
import { toast } from "react-toastify";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from 'primereact/dialog'
import SplitButton from "../../componentes/button-split/SplitButton";
import GerenciamentoBPTabela from "./GerenciamentoBPTabela";
import PageAPI from "../../componentes/pagination/Pagination-Page";
import { formatLocalDateTime } from "../../utils/formatDate";
import InputForm from "../../componentes/input/input";
import ImportarDespesasExcel from "../bp-v1/ImportarDespesasExcel";
import MeuBPRelatorioHeader from "./MeuBPHeader";
import Button from "../../componentes/button/button";
import UsuarioService from "../../services/resource/usuarioService";
import CentroCustoService from "../../services/resource/CentroCustoService";
import DespesaService from "../../services/resource/DespesaService";
import ReceitaService from "../../services/resource/ReceitaService";
import ContaContabilService from "../../services/resource/ContaContabilService";
import FilialService from "../../services/resource/filialService";
import GrupoContabilService from "../../services/resource/GrupoContabilService";
import { CustomMultiSelect } from "../../componentes/multiselect/CustomMultiSelect";
import { CustomDropdown } from "../../componentes/dropdown/CustomDropdown";
import BPLogComponent from "./BPLogComponent";
import { useAuth } from "../../context/authContext";

const initialBP = {
  content: [],
  page: {
    "size": 20,
    "number": 0,
    "totalElements": 0,
    "totalPages": 0
  }
}

function formatarDataISO(d) {
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const dia = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mes}-${dia}`;
}

export default function GerenciamentoBP() {
  const service = new BPService();
  const { user } = useAuth(); //user.perfis = ["CONTADOR", "ADMIN"]
  const isContador = user?.perfis?.includes("CONTADOR");

  const [selectedFilters, setSelectedFilters] = useState({
    centroCusto: [],
    contaContabil: [],
    filial: [],
    tipo: [],
    modo: [],
    usuarioCompartilhado: [],
    status: [],
    responsavel: [],
    status: [],
    grupo: [],
    ano: 2026
  });

  const [bplist, setBpList] = useState(initialBP);
  const [resumoOrcado, setResumoOrcado] = useState([]);
  const [dataFechamento, setDataFechamento] = useState({
    dataAtual: '',
    dataFechamento: '',
    permiteJaneiro: false,
    permiteFevereiro: false,
    permiteMarco: false,
    permiteAbril: false,
    permiteMaio: false,
    permiteJunho: false,
    permiteJulho: false,
    permiteAgosto: false,
    permiteSetembro: false,
    permiteOutubro: false,
    permiteNovembro: false,
    permiteDezembro: false
  });
  const [selectedBP, setSelectedBP] = useState(null);
  const [bpRelatorio, setBpRelatorio] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalDataFechamento, setShowModalDataFechamento] = useState(false);
  const [showModalImportDespesa, setShowModalImportDespesa] = useState(false);
  const [showModalSync, setShowModalSync] = useState(false);
  const [syncando, setSyncando] = useState(null); // "despesa" | "receita" | null
  const [syncInicio, setSyncInicio] = useState(() => {
    const d = new Date();
    return formatarDataISO(new Date(d.getFullYear(), d.getMonth(), 1));
  });
  const [syncFim, setSyncFim] = useState(() => formatarDataISO(new Date()));
  const [showModalCreate, setShowModalCreate] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalEditEmMassa, setShowModalEditEmMassa] = useState(false);
  const [showDistribuir, setShowDistribuir] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [saving, setSaving] = useState(false);
  const [valorDistribuir, setValorDistribuir] = useState(false);
  const [loading, setLoading] = useState(true);
  const [logsBP, setLogsBP] = useState([]);
  const [showLogModal, setShowLogModal] = useState(false);
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [filtros, setFiltros] = useState({
    "centroCusto": [],
    "contaContabil": [],
    "filial": [],
    "responsavel": [],
    "grupo": ["Vazio"],
    "tipo": [],
  });

  const [page, setPage] = useState({
    page: 0,
    size: 20,
    sortKey: "id",
    sortDirection: "desc"
  });

  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "asc",
  });

  const usuarioService = new UsuarioService();
  const centroService = new CentroCustoService();
  const contaService = new ContaContabilService();
  const filialService = new FilialService();
  const grupoService = new GrupoContabilService();
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [listaContas, setListaContas] = useState([]);
  const [listaCentros, setListaCentros] = useState([]);
  const [listaGrupos, setListaGrupos] = useState([]);
  const [listaFiliais, setListaFiliais] = useState([]);
  useEffect(() => {
    Promise.all([
      usuarioService.listarUsuarios(),
      centroService.listar(),
      grupoService.listar(),
      contaService.listar(),
      filialService.listar()
    ]).then(([usuariosRes, centrosRes, grupoService, contasRes, filiaisRes]) => {
      setListaUsuarios(usuariosRes.data);
      setListaCentros(centrosRes.data);
      setListaGrupos(grupoService.data);
      setListaContas(contasRes.data);
      setListaFiliais(filiaisRes.data);
    }).catch(error => {
      console.error("Erro ao carregar dados:", error);
    });
  }, []);

  const handleSort = (key) => {
    // decide a próxima direção com base no sortConfig atual
    const nextDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";

    // atualiza sortConfig (para UI, setinhas etc.)
    setSortConfig({
      key,
      direction: nextDirection,
    });

    // atualiza paginação & sort para a API
    setPage((prev) => ({
      ...prev,
      page: 0,               // opcional: volta para primeira página ao ordenar
      sortKey: key,
      sortDirection: nextDirection,
    }));
  };

  const inputDistribuirRef = useRef(null);

  const MESES = [
    "JANEIRO", "FEVEREIRO", "MARCO", "ABRIL", "MAIO", "JUNHO",
    "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO",
  ];

  useEffect(() => {
    fetchFiltros();
    document.title = "MyDash | Gerenciamento BP"
  }, []);

  useEffect(() => {
    fetchResumoOrcado();
  }, [selectedFilters?.ano])

  useEffect(() => {
    fetchBp();
    fetchRelatorio();
  }, [selectedFilters, page, sortConfig]);

  const fetchBp = () => {
    setLoading(true);
    service.listarPaginado(selectedFilters, page).then(res => {
      setBpList(res.data)
    }).finally(() => setLoading(false))
  }

  const fetchRelatorio = () => {
    setLoading(true);
    service.relatorioMeuBP(selectedFilters).then(res => {
      setBpRelatorio(res.data);

      console.log(res.data)
    }).finally(() => setLoading(false));
  }

  const fetchResumoOrcado = () => {
    service.resumoOrcado(selectedFilters?.ano || 2026).then(res => {
      setResumoOrcado(res.data);
    })
  }

  const fetchFiltros = () => {
    service.filtros().then(response => {
      const data = response.data
      setFiltros(prev => ({
        ...prev,
        centroCusto: data.centroCusto,
        contaContabil: data.contaContabil,
        filial: data.filial,
        responsavel: data.responsavel,
        tipo: data.tipo,
        grupo: ["Vazio", ...data.grupo]
      }));
    }).catch(error => {
      console.error(error)
    })
  };

  // 🔹 Abre o modal e combina os dados de 2025 e 2026
  const openModal = (row) => {
    const valores2025 = row.valoresMensaisAnterior || {};
    const valores2026 = row.valoresMensais || {};

    const comparativo = MESES.reduce((acc, mes) => {
      acc[mes] = {
        valor2025: valores2025[mes] || 0,
        valor2026: valores2026[mes] || 0,
      };
      return acc;
    }, {});

    const total2025 = Object.values(valores2025).reduce((a, b) => a + (b || 0), 0);
    const total2026 = Object.values(valores2026).reduce((a, b) => a + (b || 0), 0);

    setSelectedBP({ ...row, comparativo, total2025, total2026 });
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedBP(null);
    setShowModal(false);
  };

  const desmarcarOrcamento = () => {
    service.desmarcaContaOrcada(selectedBP.id).then(res => {
      toast.success("Conta desmarcada com sucesso!");
      closeModal();
    }).catch(error => {
      console.error(error);
    })
  }

  // 🔹 Atualiza valores mensais de 2026 no modal e recalcula totais
  const handleChangeValor2026 = (mes, novoValor) => {
    setSelectedBP((prev) => {
      const comparativoAtualizado = {
        ...prev.comparativo,
        [mes]: {
          ...prev.comparativo[mes],
          valor2026: novoValor,
        },
      };

      const total2026 = Object.values(comparativoAtualizado).reduce(
        (acc, item) => acc + (item.valor2026 || 0),
        0
      );
      const total2025 = Object.values(comparativoAtualizado).reduce(
        (acc, item) => acc + (item.valor2025 || 0),
        0
      );

      return {
        ...prev,
        comparativo: comparativoAtualizado,
        total2026,
        total2025,
      };
    });
  };

  const handleSave = async () => {
    if (!selectedBP) return;
    setSaving(true);

    const payload = {
      id: selectedBP.id,
      ano: selectedFilters?.ano,
      valoresMensais: Object.fromEntries(
        Object.entries(selectedBP.comparativo).map(([mes, dados]) => [
          mes,
          dados.valor2026,
        ])
      ),
    };

    service.atualizarValoresMensaisAdmin(payload).then(res => {
      fetchBp();
      setShowModal(false);
    }).catch(err => {
      console.error("Erro ao salvar alterações: ", err);
    }).finally(() => {
      setSaving(false);
    });
  };

  function excluir(id) {
    if (!window.confirm("Deseja realmente excluir?")) return;
    service.excluir(id)
      .then(() => {
        toast.success("Exclusão realizada com sucesso!");
        fetchBp();
      })
      .catch(err => console.error("Erro ao excluir: " + err));
  }

  function excluirEmMassa(ids) {
    if (!window.confirm(`Você selecionou ${ids.length} registros. Confirma a exclusão destes registros?`)) return;
    service.excluirEmLista(ids).then(() => {
      toast.success("Exclusão realizada com sucesso!");
      setSelectedIds([]);
      fetchBp();
    })
      .catch(err => console.error("Erro ao excluir: " + err));
  }

  function alterarEmMassa(ids) {
    setSelectedIds(ids);
    setShowModalEditEmMassa(true)
  }

  function editar(value) {
    if (value) {
      setSelectedBP(value)
    } else {
      setSelectedBP({});
    }
    setShowModalEdit(true);
  }

  const FileDownload = require('js-file-download');

  const exportExcelPorAno = () => {
    service.exportExcelPorAno(selectedFilters).then(response => {
      FileDownload(response.data, "BP 2026.xlsx");
    }).catch(error => {
      console.error(error.message);
    })
  }

  const ajustarDataFechamento = () => {
    service.ajustaDataFechamento(dataFechamento).then(res => {
      toast.success("Nova data atribuída com sucesso!");
      setShowModalDataFechamento(false);
    }).catch(e => {
      console.error(e);
    })
  }

  const sincronizarDespesas = () => {
    if (!syncInicio || !syncFim) {
      toast.error("Informe o período para sincronizar as despesas");
      return;
    }
    if (syncInicio > syncFim) {
      toast.error("A data inicial não pode ser maior que a data final");
      return;
    }

    setSyncando("despesa");
    new DespesaService().atualizaDespesas(syncInicio, syncFim).then(() => {
      toast.success("Despesas sincronizadas com sucesso!");
      fetchBp();
      fetchRelatorio();
    }).catch(e => {
      toast.error(typeof e === "string" ? e : "Erro ao sincronizar despesas");
    }).finally(() => setSyncando(null));
  }

  const sincronizarReceitas = () => {
    setSyncando("receita");
    new ReceitaService().atualizaReceitas().then(() => {
      toast.success("Receitas sincronizadas com sucesso!");
      fetchBp();
      fetchRelatorio();
    }).catch(e => {
      toast.error(typeof e === "string" ? e : "Erro ao sincronizar receitas");
    }).finally(() => setSyncando(null));
  }

  const buscaDataFechamento = () => {
    service.buscaDataFechamento().then(res => {
      setDataFechamento(res.data);
    })
  }

  const formatNumber = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("pt-BR").format(value);
  };

  const consultarLogs = async (data) => {
    if (!data) return;

    setLoadingLogs(true);

    try {
      const res = await service.buscarLogBP(data.id);
      setLogsBP(res.data);
      setShowLogModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingLogs(false);
    }
  };


  return (
    <div className="bg-background min-h-screen p-6">

      <div className="flex flex-wrap gap-2 mb-3 lg:justify-end">

        {isContador && (
          <div className="flex items-end" >
            <a href="/metas" target="_blank" className="flex items-center
                                    px-3 py-2
                                    border border-input
                                    rounded-md
                                    text-sm
                                    text-foreground
                                    shadow-xs
                                    transition-colors duration-150
                                    hover:bg-muted">
              <i className="fa fa-external-link mr-2" /> Configuração de Margem</a>
          </div>
        )}

        {isContador && (
          <div className="flex items-end" >
            <Button
              type="button"
              label="Importar Despesas DA's"
              iconLeft="fa fa-upload"
              variant="white"
              onClick={() => {
                setShowModalImportDespesa(true);
              }} />
          </div>
        )}

        {isContador && (
          <div className="flex items-end" >
            <Button
              type="button"
              label="Sincronizar Fortes"
              iconLeft="fa fa-sync"
              variant="white"
              onClick={() => setShowModalSync(true)} />
          </div>
        )}

        {isContador && (
          <div className="flex items-end" >
            <Button
              type="button"
              label="Ajustar Data Fechamento"
              iconLeft="fa fa-calendar"
              variant="white"
              onClick={() => {
                setShowModalDataFechamento(true);
                buscaDataFechamento();
              }} />
          </div>
        )}
        <div className="flex items-end" >
          <Button
            type="button"
            label="Exportar Planilha"
            iconLeft="fa fa-file-excel"
            variant="green"
            onClick={exportExcelPorAno} />
        </div>
        {isContador && (
          <div className="flex items-end">
            <Button
              type="button"
              label="Cadastrar BP"
              iconLeft="fa fa-plus"
              variant="indigo"
              onClick={() => setShowModalCreate(true)} />
          </div>
        )}
      </div>

      <div className="bg-card rounded-xl shadow-card pb-3">
        <MeuBPRelatorioHeader
          title="BP"
          subtitle="Gerenciador de Contas BP"
          data={bpRelatorio}
          loading={loading}
        />
        <div className="pb-2 pt-2 px-3">
          <Filtros
            data={filtros}
            filters={selectedFilters}
            onFiltersChange={setSelectedFilters}
          />
        </div>

        <GerenciamentoBPTabela
          data={bplist}
          openModal={openModal}
          loading={loading}
          editar={editar}
          verLogs={consultarLogs}
          relatorio={bpRelatorio}
          excluir={excluir}
          excluirEmMassa={excluirEmMassa}
          alterarResponsavelEmMassa={alterarEmMassa}
          relatorioOrcado={resumoOrcado}
          sortConfig={sortConfig}
          setSelectedIds={setSelectedIds}
          selectedIds={selectedIds}
          handleSort={handleSort}
          isContador={isContador}
        />

        <PageAPI
          page={bplist.page.number}
          size={bplist.page.size}
          totalElements={bplist.page.totalElements}
          totalPages={bplist.page.totalPages}
          loading={loading}
          onPageChange={(newPage) => setPage(prev => ({ ...prev, page: newPage }))}
          onPageSizeChange={(newSize) => setPage(prev => ({ ...prev, size: newSize }))}
        />

      </div>

      {showModal && selectedBP && (
        <Dialog
          visible={showModal}
          onHide={closeModal}
          focusOnShow={false}
          blockScroll={true}
          header={
            <div className="flex justify-between gap-2 text-sm">
              <div className="flex gap-2">
                <div className="bg-secondary text-secondary-foreground rounded-md px-2 py-1" >
                  {selectedBP.filialNome}
                </div>
                <div className="bg-primary text-primary-foreground rounded-md px-2 py-1" >
                  ({selectedBP.contaReduzido}) {selectedBP.contaDescricao}
                </div>
                <div className="bg-teal-600 text-white rounded-md px-2 py-1" >
                  ({selectedBP.centroCustoCodigo}) {selectedBP.centroCustoDescricao}
                </div>
                <div className="bg-muted text-foreground rounded-md px-2 py-1" >
                  {selectedBP.grupoDescricao}
                </div>
                <div className="bg-muted text-foreground rounded-md px-2 py-1" >
                  {selectedBP.contaTipo}
                </div>

              </div>
              <div className="flex gap-2 px-3">
                {selectedBP.compartilhado &&
                  <div className="bg-success/15 text-success rounded-md px-2 py-1" >
                    Compartilhado para: {selectedBP.usuarioCompartilhado}
                  </div>
                }

                {selectedBP.contaOrcada ?
                  <div className="bg-success/15 text-success rounded-md px-2 py-1" >
                    Realizado
                  </div>
                  :
                  <div className="bg-amber-400 text-amber-900 rounded-md px-2 py-1" >
                    Pendente
                  </div>
                }
              </div>
            </div>
          }
          footer={
            <div className="flex w-full gap-2 justify-between pt-3">
              <div>
                <Button variant="white" disabled={saving} label="Desmarcar Orçamento" onClick={desmarcarOrcamento} />
              </div>
              <div className="flex justify-end gap-2">
                <Button
                  variant="gray"
                  disabled={saving}
                  label="Cancelar"
                  iconLeft="fa fa-arrow-left"
                  onClick={closeModal} />
                <Button
                  label={"Confirmar Alterações"}
                  disabled={saving}
                  iconLeft="fa fa-thumbs-up"
                  loading={saving}
                  onClick={handleSave}
                  variant="indigo" />
              </div>
            </div>
          }
          style={{ width: '98%', height: '98%', maxHeight: '200vw' }}
        >
          <div className="p-3">
            <h4 className="text-lg font-semibold text-foreground mb-2">Orçamentos Mensais</h4>

            <div className="flex justify-between gap-4 mb-4">
              {showDistribuir ?
                <form
                  className="flex gap-2 fade-in"
                  onSubmit={() => {
                    const total = parseFloat(valorDistribuir || 0);
                    const valorPorMes = total / MESES.length;
                    MESES.forEach((mes) => handleChangeValor2026(mes, parseFloat(valorPorMes.toFixed(2))));
                    setShowDistribuir(false);
                    setValorDistribuir("");
                  }}>

                  <InputNumber
                    ref={inputDistribuirRef}
                    value={formatNumber(valorDistribuir)}
                    onValueChange={(e) => setValorDistribuir(e.target.value)}
                    mode="decimal"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    locale="pt-BR"
                    onFocus={(e) => e.target.select()}
                  />

                  <SplitButton
                    type="submit"
                    label="Confirmar"
                    iconLeft="fas fa-check-circle"
                    variant="green"
                    className="btn-sm"
                    loading={false}
                    items={[
                      {
                        label: "Inserir por Mês",
                        icon: "fas fa-edit",
                        onClick: () => {
                          const total = parseFloat(valorDistribuir || 0);
                          MESES.forEach((mes) => handleChangeValor2026(mes, parseFloat(total.toFixed(2))));
                          setShowDistribuir(false);
                          setValorDistribuir("");
                        },
                      }
                    ]}
                  />

                  <Button
                    onClick={() => {
                      setShowDistribuir(false);
                      setValorDistribuir("");
                    }}
                    variant="gray"
                    label="Cancelar"
                    iconLeft="fa fa-times"
                    className="btn-sm"
                  />

                </form>
                :
                <div className="fade-in">
                  <Button
                    onClick={() => {
                      setShowDistribuir(true);

                      setTimeout(() => {
                        inputDistribuirRef.current?.focus();
                      }, 0);

                    }}
                    variant="indigo"
                    label="Distribuir Valores Mensais"
                    className="btn-sm"
                  />
                </div>
              }

              {MESES.some((mes) => selectedBP.comparativo[mes].valor2026 > 0) && (
                <Button
                  onClick={() => {
                    MESES.forEach((mes) => handleChangeValor2026(mes, 0));
                  }}
                  variant="red"
                  label="Zerar Valores 2026"
                  className="btn-sm"
                  iconLeft="fa fa-trash"
                />
              )}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-8">
              {MESES.map((mes) => {
                const { valor2026 } = selectedBP.comparativo[mes];

                return (
                  <div key={mes} className="bg-muted p-3 rounded-lg">
                    <h5 className="text-sm font-medium text-foreground mb-1">{mes}</h5>

                    {/* Campo 2026 (editável) */}
                    <div className="flex gap-2 items-center mb-1">
                      <label className="text-xs text-muted-foreground w-10 pt-2">2026:</label>
                      <InputNumber
                        value={valor2026}
                        onValueChange={(e) => handleChangeValor2026(mes, e.value ?? 0)}
                        mode="decimal"
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        locale="pt-BR"
                        onFocus={(e) => e.target.select()}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Dialog>
      )}

      <Dialog
        visible={showLogModal}
        onHide={() => setShowLogModal(false)}
        header="Histórico de Alterações"
        className="w-[95%]"
      >
        <BPLogComponent logsBP={logsBP} />
      </Dialog>

      <Dialog
        header={<div className="grid">
          Editar Conta BP
          <div className="text-muted-foreground font-medium text-xs flex gap-3">
            <label>Filial: <label className="font-semibold">{selectedBP?.filialNome}</label> </label>
            <label>C.C: <label className="font-semibold">{selectedBP?.centroCustoCodigo}</label> </label>
            <label>Conta: <label className="font-semibold">{selectedBP?.contaReduzido}</label> </label>
          </div>
        </div>}
        headerClassName="pb-0"
        visible={showModalEdit}
        blockScroll={true}
        className="w-[95%]"
        contentClassName="p-0"
        onHide={() => setShowModalEdit(false)}
      >
        <CadastroBP
          setShowModal={setShowModalEdit}
          modo="editar"
          bpSelecionado={selectedBP}
          listaCentros={listaCentros}
          listaContas={listaContas}
          listaFiliais={listaFiliais}
          listaUsuarios={listaUsuarios}
          listaGrupos={listaGrupos}
          onSuccess={fetchBp}
        />
      </Dialog>

      <Dialog
        header={<div className="grid">
          Editar Conta BP
          <div className="text-muted-foreground font-medium text-xs flex gap-3">
            <label>Filial: <label className="font-semibold">{selectedBP?.filialNome}</label> </label>
            <label>C.C: <label className="font-semibold">{selectedBP?.centroCustoCodigo}</label> </label>
            <label>Conta: <label className="font-semibold">{selectedBP?.contaReduzido}</label> </label>
          </div>
        </div>}
        headerClassName="pb-0"
        visible={showModalEditEmMassa}
        blockScroll={true}
        className="w-[95%]"
        contentClassName="p-0"
        onHide={() => setShowModalEditEmMassa(false)}
      >
        <CadastroBP
          setShowModal={setShowModalEditEmMassa}
          modo="editar-em-massa"
          selectedIds={selectedIds}
          bpSelecionado={selectedBP}
          listaCentros={listaCentros}
          listaContas={listaContas}
          listaFiliais={listaFiliais}
          listaUsuarios={listaUsuarios}
          listaGrupos={listaGrupos}
          onSuccess={() => {
            fetchBp();
            setShowModalEditEmMassa(false);
            setSelectedIds([]);
          }}
        />
      </Dialog>

      <Dialog
        header="Cadastro de Nova Conta"
        subtitle="Cadastrar nova Conta para o BP"
        visible={showModalCreate}
        style={{ width: '95%' }}
        blockScroll={true}
        contentClassName="p-0"
        onHide={() => setShowModalCreate(false)}
      >
        <CadastroBP setShowModal={setShowModalCreate}
          modo="criar"
          onSuccess={fetchBp}
          listaCentros={listaCentros}
          listaContas={listaContas}
          listaFiliais={listaFiliais}
          listaUsuarios={listaUsuarios}
          listaGrupos={listaGrupos}
        />
      </Dialog>

      <Dialog
        header={<div className="flex flex-col">
          Importar Financeiro
          <label className="text-sm font-semibold">Importe despesas e receitas através de planilhas Excel.</label>
        </div>}
        visible={showModalImportDespesa}
        style={{ width: '95%' }}
        onHide={() => setShowModalImportDespesa(false)}
        blockScroll={true}
      >
        <ImportarDespesasExcel />
      </Dialog>

      <Dialog
        header={<div className="flex flex-col">
          Sincronizar com o Fortes
          <label className="text-sm font-semibold">Busque manualmente despesas e receitas (Logístico e Transportadora).</label>
        </div>}
        visible={showModalSync}
        style={{ width: '40rem', maxWidth: '95%' }}
        blockScroll={true}
        closable={!syncando}
        onHide={() => setShowModalSync(false)}
      >
        <div className="grid gap-4">
          <div className="border border-border rounded-lg p-4">
            <h4 className="font-semibold text-foreground mb-1">Despesas</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Recarrega as despesas lançadas no Fortes dentro do período informado.
            </p>
            <div className="grid grid-cols-2 gap-2 mb-3">
              <InputForm
                label="Data inicial"
                type="date"
                value={syncInicio}
                onChange={(e) => setSyncInicio(e.target.value)}
              />
              <InputForm
                label="Data final"
                type="date"
                value={syncFim}
                onChange={(e) => setSyncFim(e.target.value)}
              />
            </div>
            <Button
              type="button"
              label="Sincronizar Despesas"
              iconLeft="fa fa-sync"
              variant="indigo"
              loading={syncando === "despesa"}
              disabled={!!syncando}
              onClick={sincronizarDespesas} />
          </div>

          <div className="border border-border rounded-lg p-4">
            <h4 className="font-semibold text-foreground mb-1">Receitas</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Recarrega as receitas do Fortes de 01/01/2026 até o fim do mês atual.
            </p>
            <Button
              type="button"
              label="Sincronizar Receitas"
              iconLeft="fa fa-sync"
              variant="indigo"
              loading={syncando === "receita"}
              disabled={!!syncando}
              onClick={sincronizarReceitas} />
          </div>
        </div>
      </Dialog>

      <Modal
        title="Configuração de Contas BP"
        subtitle="Alterar data de permissão | Bloqueio de Meses | Bloqueio de Contas Duplicadas"
        isOpen={showModalDataFechamento}
        onClose={() => setShowModalDataFechamento(false)}
        footer={
          <div className="flex justify-end gap-2 mt-3">
            <Button
              label="Cancelar"
              variant="gray"
              iconLeft="fa fa-arrow-left"
              onClick={() => setShowModalDataFechamento(false)} />
            <Button
              label="Confirmar"
              iconLeft="fa fa-save"
              onClick={ajustarDataFechamento}
              variant="indigo"
            />
          </div>
        }
      >

        <div className="space-y-4 p-6">
          <p className="text-foreground">
            Data atual de fechamento das contas BP:{" "}
            <strong>
              {formatLocalDateTime(dataFechamento.dataFechamento + ":00")}
            </strong>
          </p>

          <InputForm
            label="Nova data de fechamento"
            type="datetime-local"
            value={dataFechamento.dataFechamento}
            onChange={(e) =>
              setDataFechamento((prev) => ({
                ...prev,
                dataFechamento: e.target.value
              }))
            }
            className="border rounded px-3 py-2 w-full"
          />

          <div>
            <h4 className="font-semibold text-foreground mb-3">
              Meses permitidos para edição
            </h4>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {[
                { key: "permiteJaneiro", label: "Janeiro" },
                { key: "permiteFevereiro", label: "Fevereiro" },
                { key: "permiteMarco", label: "Março" },
                { key: "permiteAbril", label: "Abril" },
                { key: "permiteMaio", label: "Maio" },
                { key: "permiteJunho", label: "Junho" },
                { key: "permiteJulho", label: "Julho" },
                { key: "permiteAgosto", label: "Agosto" },
                { key: "permiteSetembro", label: "Setembro" },
                { key: "permiteOutubro", label: "Outubro" },
                { key: "permiteNovembro", label: "Novembro" },
                { key: "permiteDezembro", label: "Dezembro" }
              ].map((mes) => (
                <label
                  key={mes.key}
                  className="flex items-center gap-2 border rounded px-3 py-2"
                >
                  <input
                    type="checkbox"
                    checked={dataFechamento[mes.key]}
                    onChange={(e) =>
                      setDataFechamento((prev) => ({
                        ...prev,
                        [mes.key]: e.target.checked
                      }))
                    }
                  />
                  {mes.label}
                </label>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-3">
              Bloqueios de duplicadas
            </h4>

            <div className="grid grid-cols-2 md:grid-cols-2 gap-3">
              <label

                className="flex items-center gap-2 border rounded px-3 py-2"
              >
                <input
                  type="checkbox"
                  checked={dataFechamento.bloqueiaContaDuplicada}
                  onChange={(e) =>
                    setDataFechamento((prev) => ({
                      ...prev,
                      bloqueiaContaDuplicada: e.target.checked
                    }))
                  }
                />
                Bloqueia Criação de Contas Duplicadas
              </label>

            </div>
          </div>

        </div>

      </Modal>
    </div>
  );
}

const Filtros = ({ data, filters, onFiltersChange }) => {

  const updateFilter = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    onFiltersChange(prev => ({
      ...prev,
      centroCusto: [],
      contaContabil: [],
      filial: [],
      tipo: [],
      modo: [],
      responsavel: [],
      grupo: [],
      usuarioCompartilhado: [],
      status: []
    }));
  };

  // Gerando options dinamicamente
  const centroCustoOptions = data.centroCusto?.map(item => ({
    label: `${item.codigo} - ${item.descricao}`,
    value: item.codigo
  })) || [];

  const contaContabilOptions = data.contaContabil?.map(item => ({
    label: `${item.codigo} - ${item.descricao}`,
    value: item.codigo
  })) || [];

  const filialOptions = data.filial?.map(item => ({
    label: item,
    value: item
  })) || [];

  const responsavelOptions = data.responsavel?.map(item => ({
    label: item,
    value: item
  })) || [];


  const grupoOptions = data.grupo?.map(item => ({
    label: item,
    value: item
  })) || [];

  const tipoOptions = data.tipo?.map(item => ({
    label: item,
    value: item
  })) || [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-8 gap-3 mt-4">
      <div className="col-span-2">
        <label className={`block text-sm font-medium text-foreground mb-1`}>
          Filtro por Conta
        </label>
        <CustomMultiSelect
          value={filters.contaContabil}
          options={contaContabilOptions}
          onChange={value => updateFilter("contaContabil", value)}
          display="chip"
          className="w-full text-xs border rounded rounded-lg"
          filter
          showClear
        />
      </div>

      <div className="col-span-2">
        <label
          className={`block text-sm font-medium text-foreground mb-1`}>
          Filtro por Centro de Custo
        </label>
        <CustomMultiSelect
          value={filters.centroCusto}
          options={centroCustoOptions}
          onChange={value => updateFilter("centroCusto", value)}
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      <div className="col-span-2">
        <label
          className={`block text-sm font-medium text-foreground mb-1`}>
          Filtro por Filial
        </label>
        <CustomMultiSelect
          value={filters.filial}
          options={filialOptions}
          onChange={value => updateFilter("filial", value)}
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      <div className="col-span-2">
        <label className={`block text-sm font-medium text-foreground mb-1`}        >
          Filtro por Tipo
        </label>
        <CustomMultiSelect
          value={filters.tipo}
          options={tipoOptions}
          onChange={value => updateFilter("tipo", value)}
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      <div className="col-span-2">
        <label className={`block text-sm font-medium text-foreground mb-1`}        >
          Filtro por Responsável
        </label>
        <CustomMultiSelect
          value={filters.responsavel}
          options={responsavelOptions}
          onChange={value => updateFilter("responsavel", value)}
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>
      <div className="col-span-2">
        <label className={`block text-sm font-medium text-foreground mb-1`}        >
          Filtro por Grupo
        </label>
        <CustomMultiSelect
          value={filters.grupo}
          options={grupoOptions}
          onChange={value => updateFilter("grupo", value)}
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      <div className="col-span-2">
        <label className={`block text-sm font-medium text-foreground mb-1`}        >
          Filtro por Status
        </label>
        <CustomMultiSelect
          value={filters.status}
          options={[
            { label: 'Realizado', value: true },
            { label: 'Pendente', value: false },
          ]}
          onChange={value => updateFilter('status', value)}
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>
      <div>
        <label className={`block text-sm font-medium text-foreground mb-1`}>
          Filtro por Ano
        </label>
        <CustomDropdown
          optional
          options={[
            { value: 2025, label: '2025' },
            { value: 2026, label: '2026' }
          ]}
          className="w-full text-xs border"
          optionLabel="label"
          optionValue="value"
          value={filters.ano}
          onChange={e => updateFilter("ano", e.value)}
        />
      </div>

      <div className="flex items-end">
        {(filters.centroCusto.length ||
          filters.contaContabil.length ||
          filters.filial.length ||
          filters.tipo.length ||
          filters.modo.length ||
          filters.usuarioCompartilhado.length ||
          filters.status.length) > 0 && (
            <Button
              label="Limpar Filtros"
              iconLeft="fa fa-eraser"
              onClick={clearFilters}
            />
          )}
      </div>


    </div>
  );
}